<footer class="text-white md:text-start text-center bg-[#1E1E48]">
  <div class="container max-w-full mx-auto px-4 py-10 mt-[14px] cw:px-[max(32px,calc((100%_-_1328px)/2))]">
    <div class="flex flex-col lg:flex-row lg:justify-between gap-10 lg:gap-16">
      <!-- Logo Section -->
      <div class="w-full lg:max-w-[330px] flex flex-col items-center lg:items-start text-center lg:text-start">
        <img src="icons/white_Logo.svg" alt="logo" class="w-38" />

        <h4 class="py-4 text-[16px]">
          {{ "Home_Page.Footer.Slogan" | translate }}
        </h4>

        <div class="flex flex-wrap justify-center lg:justify-start gap-3">
          <img src="icons/visa2.svg" alt="visa" />
          <img src="icons/mastercard.svg" alt="mastercard" />
          <img src="icons/google-pay.svg" alt="google-pay" />
          <img src="icons/apple-pay.svg" alt="apple-pay" />
          <img src="icons/recolut.svg" alt="recolut" />
        </div>
      </div>

      <!-- Links -->
      <div class="flex-1 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-y-4 text-center lg:text-start items-start">
        <!-- Dream -->
        <div>
          <h4 class="font-semibold text-[18px] mb-4">
            {{ "Home_Page.Footer.Explore" | translate }}
          </h4>

          <ul class="space-y-3 text-[15px]">
            <li>
              <a routerLink="/about">
                {{ "Home_Page.Footer.About" | translate }}
              </a>
            </li>
            @if (isLoggedIn()) {

            <li>
              <a routerLink="/manage-account" [queryParams]="{ tab: 'bookings' }">
                {{ "Manage_Account.Tab_Bookings" | translate }}
              </a>
            </li>
            }
            <li>
              <a routerLink="/contact-us">
                {{ "Home_Page.Footer.Contact" | translate }}
              </a>
            </li>
            @if (!isLoggedIn()) {
            <li>
              <a routerLink="/business">
                {{ "Home_Page.Become_Partner" | translate }}
              </a>
            </li>
            }
            <li>
              <a routerLink="/faqs">
                {{ "Home_Page.Footer.FAQS" | translate }}
              </a>
            </li>
            <li>
              <a routerLink="/feedback">
                {{ "Feedback.Title" | translate }}
              </a>
            </li>
          </ul>
        </div>

        <!-- Legal -->
        <div>
          <h4 class="font-semibold text-[18px] mb-4">
            {{ "Home_Page.Footer.Legal" | translate }}
          </h4>

          <ul class="space-y-3 text-[15px]">
            <li>
              <a routerLink="/terms-conditions">
                {{ "Home_Page.Footer.Terms" | translate }}
              </a>
            </li>

            <li>
              <a routerLink="/privacy">
                {{ "Home_Page.Footer.Privacy" | translate }}
              </a>
            </li>

            <!-- <li>
              <a routerLink="/terms-of-use">
                {{ "Home_Page.Footer.Use" | translate }}
              </a>
            </li> -->
          </ul>
        </div>

        <div>
          <h4 class="font-semibold text-[18px] mb-4">
            {{ "Home_Page.Footer.Certified" | translate }}
          </h4>

          <div class="flex items-center justify-center lg:justify-start gap-3">
            <img src="icons/simplification.svg" class="w-[52px] h-[52px] object-contain shrink-0" />
            <a class="text-[14px] leading-tight !cursor-auto">
              {{ "Home_Page.Footer.Iata_Travel" | translate }}
            </a>
          </div>
        </div>
        <div>
          <h4 class="font-semibold text-[18px] mb-2 lg:mb-1 xl:mb-4">
            {{ "Home_Page.Footer.Support" | translate }}
          </h4>

          <div class="flex items-center justify-center lg:justify-start gap-3">
            <img src="icons/sms.svg" alt="sms" />

            <a href="mailto:support&#64;dreamnfly.com" class="text-[14px] mb-1">
              support&#64;dreamnfly.com
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>

  <section class="Copyright border-t border-t-[#A5A6A8]">
    <div
      class="bg-[#1E1E48] py-10 md:py-4 grid gap-y-4 grid-cols-1 md:grid-cols-2 items-center container max-w-full mx-auto px-4 cw:px-[max(32px,calc((100%_-_1328px)/2))]">
      <h4 class="order-2 text-[#FFFFFF] md:order-1">
        {{ "Home_Page.Footer.Copyright" | translate }}
      </h4>

      <div class="flex items-center justify-center order-1 gap-6 md:gap-4 md:justify-end md:order-2">
        <!-- <a class="links">
          <img src="/icons/instgram.svg" alt="instagram-icon" />
        </a>

        <a class="links">
          <img src="/icons/instgram.svg" alt="instagram-icon" />
        </a> -->

        <button (click)="scrollToTop()" class="flex items-center justify-center w-9 h-9 bg-white rounded-full">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6 text-secondary" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 15l6-6 6 6" />
          </svg>
        </button>
      </div>
    </div>
  </section>
</footer>